import React, { useState } from 'react';
import { X, Globe } from 'lucide-react';
import { createDomain } from '../services/firestore';

export default function AddDomainModal({ isOpen, onClose, user, onSuccess }) {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      setError('You must be logged in to post');
      return;
    }

    try {
      setLoading(true);
      setError('');

      await createDomain({
        name: name.toLowerCase().trim(),
        price,
        owner: user.displayName || user.email || 'Anonymous'
      }, user.uid);

      onSuccess?.();
      onClose();

      // Reset form
      setName('');
      setPrice('');
    } catch (err) {
      setError(err.message || 'Failed to add domain');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-slate-900 rounded-2xl p-8 max-w-md w-full border border-slate-800 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white flex items-center gap-2">
            <Globe className="text-amber-500" />
            Add to Graveyard
          </h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <X className="w-6 h-6" />
          </button>
        </div>

        <p className="text-slate-400 text-sm mb-6">
          Share that domain you bought at 3am and instantly regretted.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-bold text-slate-300 mb-2">Domain Name*</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., blockchain-toilet.com"
              className="w-full bg-slate-800 text-white px-4 py-3 rounded-lg border border-slate-700 focus:border-amber-500 focus:outline-none font-mono"
              required
              pattern="[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
            />
            <div className="text-xs text-slate-500 mt-1">Include the extension (.com, .io, etc.)</div>
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-300 mb-2">Price Paid*</label>
            <input
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="e.g., $3000 or $12/yr"
              className="w-full bg-slate-800 text-white px-4 py-3 rounded-lg border border-slate-700 focus:border-amber-500 focus:outline-none"
              required
            />
            <div className="text-xs text-slate-500 mt-1">How much damage to your wallet?</div>
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-2 rounded-lg text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold py-4 rounded-lg transition disabled:opacity-50"
          >
            {loading ? 'Adding...' : 'Add to Graveyard 💀'}
          </button>
        </form>
      </div>
    </div>
  );
}
